import { render, staticRenderFns } from "./ApproverStateUpload.vue?vue&type=template&id=81b8e2d4&"
import script from "./ApproverStateUpload.vue?vue&type=script&lang=js&"
export * from "./ApproverStateUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports